export default __webpack_public_path__ + "static/media/dis.ccf71f97.svg";